/**
* @module Internet FAQs
* @description
*/
import Link from 'next/link';
import FAQs from '@/blocks/FAQS';
import { trackEvent } from '@/js/helpers/tracking';

/**
 * @function Component
 * @description Hero that displays headline and predictive service check
 */
const Component = () => {
  /**
   * @function handleClick
   * @description
   */
  const handleClick = ( event ) => {
    const { target } = event;
    const text = target.innerHTML;
    const data = {
      elementType: 'LINK',
      position: 'FAQ',
      text,
      actionOutcome: 'INTERNALLINK'
    };

    trackEvent( { action: 'elementClicked', data, event } );
  };

  return (
    <FAQs
      accordionData={ [
        {
          title: 'Is Frontier Fiber available in my neighborhood?',
          content: <>Frontier Internet services vary by location. <Link
            key="link-1"
            href="/local"
            onClick={ handleClick }
            aria-label="Link to local page">Learn More</Link> about which plans are available at your address.</>,
          contentRaw: 'Frontier Internet services vary by location. Learn More about which plans are available at your address.'
        },
        {
          title: 'Do Frontier plans require term contracts?',
          content: 'Some of our plans include optional gift cards or included expert installation that require a 12-month commitment.'
        },
        {
          title: 'Which Frontier Internet plan is best for me?',
          content: 'Frontier offers communications services including Internet and Home Phone. Options will vary by location, so check with us to see which specific plans may be available at your address.'
        }
      ] }
    />
  );
};

export default Component;
